import { Alert } from '@mui/material';
import type { FC } from 'react';

export const ErrorView: FC<{ error?: Error }> = ({ error }) => (
  <Alert severity="error">{error?.message}</Alert>
);
